import Layout from '../../internal/Layout.vue'
import IntegrationsPage from './integrations.vue'

const IntegrationsRoutes = {
  component: Layout,
  children: [
    {
      name: 'integracoes',
      path: '/integracoes',
      component: IntegrationsPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
      },
    },
  ],
}

export default IntegrationsRoutes
